import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Save, Trash2 } from "lucide-react";

// Dialog para salvar um conjunto de permissões marcado como preset customizado (perm-preset).
export function SavePresetDialog({ open, onClose, name, onNameChange, permissionsCount, currentEmpresaId, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="dialog-save-preset">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-emerald-700">
            <Save className="w-5 h-5" />Salvar preset de permissão
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="text-xs text-muted-foreground">
            Salva as <b>{permissionsCount || 0}</b> permissões marcadas como um novo preset reutilizável.
            {currentEmpresaId ? " Vinculado à empresa ativa." : " Selecione uma empresa antes de salvar."}
          </div>
          <div>
            <Label className="text-xs">Nome do preset</Label>
            <Input value={name} onChange={(e) => onNameChange(e.target.value)}
              placeholder="Ex: Turno Noite · Balcão Farmacêutico"
              data-testid="input-preset-name"
              onKeyDown={(e) => { if (e.key === "Enter") onConfirm(); }}
              autoFocus />
          </div>
          <div className="flex gap-2 justify-end pt-1">
            <Button variant="ghost" onClick={onClose}>Cancelar</Button>
            <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={onConfirm} data-testid="btn-confirm-save-preset">
              <Save className="w-4 h-4 mr-1" />Salvar preset
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

// Barra flutuante para exclusão em lote quando há usuários selecionados.
export function BulkDeleteBar({ count, onCancel, onDelete }) {
  if (count === 0) return null;
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-white shadow-2xl border-2 border-rose-300 rounded-full px-4 py-2 flex items-center gap-3" data-testid="bulk-bar-users">
      <span className="text-sm font-semibold text-rose-700"><b>{count}</b> selecionado(s)</span>
      <Button size="sm" variant="ghost" onClick={onCancel} className="text-xs h-7">Cancelar</Button>
      <Button size="sm" className="bg-rose-600 hover:bg-rose-700 h-8" onClick={onDelete} data-testid="btn-bulk-delete-users">
        <Trash2 className="w-4 h-4 mr-1" />Excluir Selecionados
      </Button>
    </div>
  );
}
